import { useQuery } from "@tanstack/react-query";
import { CatalogoDisparo } from "@/models/consignado/disparo.model";
import { buscarCatalogoDisparo } from "@/services/consignado/disparo.service";

// Os seis GET /disparos/catalogo/* (HIS-APP-notificacoes-007), buscados em
// paralelo. É o cardápio do formulário: eventos, propriedades filtráveis,
// combinações canal × provedor, formatos e frequências.
//
// Cache longo porque o catálogo muda com deploy do backend, não durante a
// sessão do operador — a exceção é a tabela de eventos, que é dado vivo,
// mas ainda assim raro de mudar no meio de um cadastro.
export const CATALOGO_DISPARO_QUERY_KEY = "catalogo-disparo";

export function useCatalogoDisparo(enabled = true) {
  return useQuery<CatalogoDisparo>({
    queryKey: [CATALOGO_DISPARO_QUERY_KEY],
    queryFn: buscarCatalogoDisparo,
    enabled,
    retry: 0,
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000,
  });
}
